import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { DashboardRequestResponse, DashboardResponseManager, DashboardResponseUser } from "../../../business/core";
import { DashboardFactory } from "../../interfaces";
import { DashboardManagerContent, DashboardUserContent } from "../screens/components";

export class DashboardFactoryImpl implements DashboardFactory {
    create(data: DashboardRequestResponse | null, userSession: string | undefined): ReactElement<any, string | JSXElementConstructor<any>> {
        if (data === null) return <NoDataComponent />
        if (!data || !data.response) return <NoDataComponent />
        if (!data.success) return <p>{data.response.toString()}</p>

        if (userSession === 'manager') {
            return <DashboardManagerContent response={data.response as DashboardResponseManager} />
        }
        return <DashboardUserContent response={data.response as DashboardResponseUser} />
    }

}